export default {
    alerts: {
        index: {
            error: 'Failure during the search',
        },
    },
    lead: 'Leads',
    customer: 'Customers',
    fullName: 'Full name',
    note: 'Notes',
    recent: 'Recent leads',
    recentSearch: 'Recent searches',
    recentViewed: 'Recently viewed',
    results: 'Results',
    search: 'Search...',
    startTyping: 'Start typing to search...',
    user: 'Users',
    vehicle: 'Vehicles',
    viewAll: 'View all results',
    delete: 'Delete',
};
